import { useCallback, useState } from "react";
import AwaitType from "../../../utils/AwaitType";
import {
  createCompany,
  deleteCompany,
  TCreateCompanyData,
  updateCompany,
} from "../network";
import { ICompanyActionModeType } from "../models";
import { ActionType } from "../../../models/ActionType";

export type TResult = null | AwaitType<ReturnType<typeof createCompany>>;

export const useCompanyAction = (
  mode: ICompanyActionModeType
): [
  TResult | boolean,
  boolean,
  Error | null,
  (data: TCreateCompanyData | string) => void,
  React.Dispatch<React.SetStateAction<Error | null>>
] => {
  const [result, setResult] = useState<TResult | boolean>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(
    async (data: TCreateCompanyData | string) => {
      setIsLoading(true);
      setError(null);

      try {
        const response =
          mode === ActionType.EDIT
            ? await updateCompany(data as TCreateCompanyData)
            : mode === ActionType.DELETE
            ? await deleteCompany(data as string)
            : await createCompany(data as TCreateCompanyData);
        setResult(response);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
      }
      setIsLoading(false);
    },
    [mode]
  );

  return [result, isLoading, error, request, setError];
};
